import { render } from "./ComponenteConfiguracionGeneral.vue?vue&type=template&id=bea507aa"
import script from "./ComponenteConfiguracionGeneral.vue?vue&type=script&lang=js"
export * from "./ComponenteConfiguracionGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__